
import { apiIntegralCategoryDel, apiIntegralCategoryLists, apiIntegralCategoryStatus } from '@/api/application/integral_mall'
import { RequestPaging } from '@/utils/util'
import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'
import LsPagination from '@/components/ls-pagination.vue'
import ExportData from '@/components/export-data/index.vue'
@Component({
    components: {
        LsDialog,
        LsPagination,
        ExportData
    }
})
export default class Brand extends Vue {
    queryObj = {
        name: ''
    }
    pager = new RequestPaging()
    apiBrandLists = apiIntegralCategoryLists
    getList(page?: number): void {
        page && (this.pager.page = page)
        this.pager.request({
            callback: apiIntegralCategoryLists,
            params: {
                ...this.queryObj
            }
        })
    }
    handleReset() {
        this.queryObj = {
            name: ''
        }
        this.getList()
    }
    handleStatus(value: number, id: number) {
        apiIntegralCategoryStatus({
            id,
            is_show: value
        }).then(() => {
            this.getList()
        })
    }

    handleDelete(id: number) {
        apiIntegralCategoryDel({ id }).then(() => {
            this.getList()
        })
    }

    created() {
        this.getList()
    }
    activated() {
        this.getList()
    }
}
